module.exports = __webpack_public_path__ + "img/battery-3.be4482e8.svg";